import NProgress from 'nprogress'

export function configureAxiosInterceptors() {
	NProgress.configure({
		showSpinner: false
	})

	window.axios.interceptors.request.use(config => {
		NProgress.start()

		return config
	})

	window.axios.interceptors.response.use((response) => {
		NProgress.done()

		return Promise.resolve(response)
	}, (error) => {
		NProgress.done()

		let data = error.response?.data ?? {}

		if (error.response?.status === 512) {
			window.location.replace(route('showLoginForm'))
		}

		if (data.error) {
			Toast.fire({icon: 'error', title: data.error}).then()
		} else if (data.message) {
			Toast.fire({icon: 'error', title: data.message}).then()
		}

		return Promise.reject(error.response)
	})
}
